<template>
  <div class="card mb-3">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <div class="row">
        <div class="col-md-3">
          <label>از تاریخ</label>
          <Datepicker
            simple
            auto-submit
            id="from-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :max="today"
            v-model="fromDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="col-md-3">
          <label> تا تاریخ</label>
          <Datepicker
            simple
            auto-submit
            id="to-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :max="today"
            v-model="toDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>سازمان</label>
            <select required class="form-control mb-3" v-model="orgenizationId">
              <option value="">سازمان خود را انتخاب کنید</option>
              <option
                v-for="(org, index) in orgenizationList"
                :key="index"
                :value="org.orgId"
              >
                <div
                  class="d-flex w-100 flex-1 flex-row justify-content-between"
                >
                  <span> {{ org.companyName }} </span>
                  <span class="mx-2">
                    - {{ numberFormat(org.balance) }} ریال</span
                  >
                </div>
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row" style="display: flex; justify-content: end;">
        <!-- <div class="col-md-3" style="margin-top: 29px;" v-if="rows && rows.length">
                    <button class="btn btn-secondary" @click="downloadExcelFile">
                        دریافت خروجی Excel
                    </button>
                </div> -->
        <div v-if="isSearched" class="col-md-3" style="margin-top: 29px;">
          <button class="btn btn-info btn-block" @click="getFullExelPath">
            دریافت فایل اکسل کل
          </button>
        </div>
        <div class="col-md-3" style="margin-top: 29px;">
          <button class="btn btn-primary btn-block" @click="submit">
            <i class="si si-magnifier"></i>
            جستجو
          </button>
        </div>
      </div>
      <div
        class="alert alert-info mt-4 mb-0"
        v-if="rows && !rows.length && isSearched"
      >
        <p class="mb-0">اطلاعاتی یافت نشد</p>
      </div>
      <hr v-if="rows && rows.length" />
      <table
        class="table table-hover table-bordered mb-0"
        v-if="rows && rows.length"
      >
        <thead>
          <tr>
            <th>نام سازمان</th>
            <th>نام سوییچ</th>
            <th>مبلغ (ریال)</th>
            <th>وضعیت</th>
            <th>تصویر فیش واریز</th>
            <th>تاریخ</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>
              {{ row.comanyName ? row.comanyName : "بدون نام" }}
            </td>
            <td>
              {{ row.switchName ? row.switchName : "بدون نام" }}
            </td>
            <td>
              {{
                row.amount
                  ? new Intl.NumberFormat("en-IR", {
                      maximumSignificantDigits: 20,
                    }).format(row.amount)
                  : "0"
              }}
            </td>
            <td v-if="row.status == 1" class="text-warning">
              <i class="text-warning m-1 ti-timer"></i>{{ row.statusTitle }}
            </td>
            <td v-else-if="row.status == 3" class="text-danger">
              {{ row.statusTitle }}
            </td>
            <td v-else class="text-success">
              <i class="ti-tick m-1 text-success"> </i>{{ row.statusTitle }}
            </td>
            <td v-if="row.imageFile" class="text-success">
              <i class="ti-download m-1 text-success"> </i>
              بار‌گذاری شده
            </td>
            <td v-else class="text-danger">
              <i class="ti-alert text-danger  m-1"></i>
              بار‌گذاری نشده است
            </td>
            <td v-if="row.insertDate">
              {{
                row.insertDate.replace(/\//g, "").slice(0, 4) +
                  "/" +
                  row.insertDate.replace(/\//g, "").slice(4, 6) +
                  "/" +
                  row.insertDate.replace(/\//g, "").slice(6, 8)
              }}
            </td>
            <td v-else>
              -
            </td>
            <td>
              <router-link
                :to="{
                  name: 'organizationCharge.detail',
                  params: { id: row.id },
                }"
                class="d-inline-block ml-2"
                title="مشاهده"
                ><i class="ti-eye operationsIcon"></i
              ></router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="row mt-3"
        v-if="pages && pages.length > 1"
        style="overflow-x: hidden;"
      >
        <div class="col-12" style="overflow-x: auto;">
          <ul class="pagination pagination-circled">
            <li class="page-item" v-if="currentPage > 1">
              <a class="page-link" href="#" v-on:click="currentPage--"
                ><i class="icon ion-ios-arrow-forward"></i
              ></a>
            </li>
            <li
              :class="currentPage == page ? 'page-item active' : 'page-item'"
              v-for="page in pages"
              :key="page"
            >
              <a class="page-link" href="#" v-on:click="currentPage = page">{{
                page
              }}</a>
            </li>
            <li class="page-item" v-if="pages.length != currentPage">
              <a class="page-link" href="#" v-on:click="currentPage++"
                ><i class="icon ion-ios-arrow-back"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  name: "ChargeList",
  data() {
    return {
      showLoading: false,
      isSearched: false,
      rows: [],
      orgenizationList: [],
      orgenizationId: "",
      fromDate: "",
      toDate: "",
      currentPage: 1,
      pages: [1],
      perPage: 10,
      today: moment().format("jYYYY-jMM-jDD"),
      count: 0,
    };
  },
  watch: {
    currentPage(value) {
      this.currentPage = value;
      this.getData();
    },
  },
  methods: {
    numberFormat(input, isAmount) {
      let value = input.toString().replace(/,/g, "");
      value = new Intl.NumberFormat("en-IR", {
        maximumSignificantDigits: 20,
      }).format(value);
      if (value == "NaN") value = "";

      if (isAmount) this.amount = value;
      else return value;
    },
    getOrgenizationData() {
      this.$api
        .post("Organizations/OrganizationChargeWallet/GetOrganization", {})
        .then(({ data }) => {
          if (data.status) {
            this.orgenizationList = data.result.data;
          }
        });
    },
    getFullExelPath() {
      this.showLoading = true;
      const postedData = {
        // fromDate: this.fromDate.replace(/\//g, ""),
        // toDate: this.toDate.replace(/\//g, ""),
        page: 0,
        perPage: this.count,
        orgId: this.orgenizationId,
      };
      this.$api
        .post(
          "Organizations/OrganizationChargeWallet/GetCreditChargeOrganizationExcel",
          postedData
        )
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.data.fileName
            );
            let fileName = data.result.data.filename;
            a.setAttribute("target", "_blank");
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
            this.rows = result;
            this.count = data.result.count;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    getData() {
      this.showLoading = true;
      const postedData = {
        // fromDate: this.fromDate.replace(/\//g, ""),
        // toDate: this.toDate.replace(/\//g, ""),
        page: this.currentPage - 1,
        perPage: this.perPage,
        orgId: this.orgenizationId,
      };
      this.$api
        .post(
          "Organizations/OrganizationChargeWallet/GetCreditChargeOrganization",
          postedData
        )
        .then(({ data }) => {
          if (data.status && data.result && data.result.data) {
            this.rows = data.result.data.list;
            this.count = data.result.data.totalCount;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          } else {
            this.rows = [];
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    downloadExcelFile() {
      this.getData(true);
    },
    submit() {
      this.getData();
    },
  },
  created() {
    this.getOrgenizationData();
  },
};
</script>
